import React, { useCallback } from "react";
import { Result, Button } from "antd";
import { useIntl } from "react-intl";

const LoadError = ({ onClick, message, buttonText }) => {
  const intl = useIntl();
  const handleClick = useCallback(() => {
    onClick();
  }, [onClick]);
  
  return (
    <Result
      status="warning"
      title={message}
      extra={
        onClick && (
          <Button type="primary" onClick={handleClick}>
            {buttonText ||
              intl.formatMessage({
                id: "messages.loadAgain",
                defaultMessage: "Načíst znovu",
              })}
          </Button>
        )
      }
    />
  );
};

export default LoadError;
